import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Menu, X, Clapperboard } from 'lucide-react';
import { Button } from '../ui/button';
import { useAuth } from '../../context/AuthContext';

const LINKS = [
  { to: '/features', label: 'Features' },
  { to: '/ai-editor', label: 'AI Editor' },
  { to: '/voiceover', label: 'Voiceover' },
  { to: '/templates', label: 'Templates' },
  { to: '/pricing', label: 'Pricing' },
];

export function Logo({ className = '' }) {
  return (
    <Link to="/" className={`flex items-center gap-2 group ${className}`} data-testid="logo-link">
      <span className="grid place-items-center w-9 h-9 rounded-lg bg-gradient-to-br from-[#FF4D00] to-[#8B5CF6] shadow-lg shadow-[#FF4D00]/20">
        <Clapperboard className="w-5 h-5 text-white" />
      </span>
      <span className="font-heading font-extrabold text-lg tracking-tight">TubeEditor <span className="text-gradient">AI</span></span>
    </Link>
  );
}

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-50 glass border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(' ', '-')}`}
              className="text-sm text-slate-300 hover:text-white transition-colors">{l.label}</Link>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <Button data-testid="nav-dashboard-btn" onClick={() => nav('/app')} className="rounded-full">Dashboard</Button>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm text-slate-300 hover:text-white transition-colors">Log in</Link>
              <Button data-testid="nav-signup-btn" onClick={() => nav('/signup')} className="rounded-full font-semibold">Start Creating Free</Button>
            </>
          )}
        </div>
        <button className="lg:hidden text-slate-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden glass border-t border-white/10 px-5 py-4 flex flex-col gap-3">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-slate-300 py-1">{l.label}</Link>
          ))}
          {user ? (
            <Button onClick={() => nav('/app')} className="rounded-full">Dashboard</Button>
          ) : (
            <>
              <Link to="/login" className="text-slate-300 py-1">Log in</Link>
              <Button onClick={() => nav('/signup')} className="rounded-full">Start Creating Free</Button>
            </>
          )}
        </div>
      )}
    </header>
  );
}
